import { Link } from "react-router-dom";
import { LOGO } from "@/lib/api";

export const Footer = () => (
  <footer className="bg-[#0B1D3A] text-white mt-24" data-testid="site-footer">
    <div className="stripe-bar h-1.5" />
    <div className="max-w-7xl mx-auto px-4 py-14 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="bg-white inline-block px-4 py-3 rounded"><img src={LOGO} alt="FAUNNY" className="h-20" /></div>
        <p className="mt-5 text-blue-100 text-sm max-w-md leading-relaxed">
          Nutrición natural para caballos que dan lo mejor de sí. Complementos nutricionales y productos de salud e higiene diseñados, envasados y distribuidos por SAVI Nutri Tech.
        </p>
        <p className="mt-3 text-blue-200 text-sm">info@faunny.com</p>
      </div>
      <div>
        <h4 className="font-display text-lg font-bold mb-3">Tienda</h4>
        <ul className="space-y-2 text-sm text-blue-100">
          <li><Link to="/tienda?line=complementos" className="hover:text-white">Complementos nutricionales</Link></li>
          <li><Link to="/tienda?line=salud" className="hover:text-white">Salud e higiene</Link></li>
          <li><Link to="/tienda" className="hover:text-white">Todos los productos</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-lg font-bold mb-3">Te ayudamos</h4>
        <ul className="space-y-2 text-sm text-blue-100">
          <li><Link to="/calculadora" className="hover:text-white">Calculadora de dieta</Link></li>
          <li><Link to="/diagnostico" className="hover:text-white">Diagnóstico FAUNNY</Link></li>
          <li><Link to="/guia" className="hover:text-white">Guía de salud y prevención</Link></li>
          <li><Link to="/asesor" className="hover:text-white">Asesor FAUNNY (IA)</Link></li>
          <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
          <li><Link to="/cuadra" className="hover:text-white" data-testid="footer-cuadra">Mi cuadra</Link></li>
          <li><Link to="/concursos" className="hover:text-white" data-testid="footer-concursos">Calendario de concursos</Link></li>
          <li><Link to="/mercado" className="hover:text-white" data-testid="footer-mercado">Compraventa de caballos</Link></li>
          <li><Link to="/mercado/guarnicioneria" className="hover:text-white" data-testid="footer-guarnicioneria">Guarnicionería y accesorios</Link></li>
          <li><Link to="/mercado/vans" className="hover:text-white" data-testid="footer-vans">Vans y camiones</Link></li>
          <li><Link to="/adopcion" className="hover:text-white" data-testid="footer-adopcion">Adopción de animales</Link></li>
          <li><Link to="/cuenta" className="hover:text-white">Mi cuenta</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-blue-200 px-4">
      <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mb-3 text-sm" data-testid="footer-legal-links">
        <Link to="/legal/aviso-legal" className="hover:text-white">Aviso legal</Link>
        <Link to="/legal/privacidad" className="hover:text-white">Privacidad</Link>
        <Link to="/legal/cookies" className="hover:text-white">Cookies</Link>
        <Link to="/legal/condiciones-de-venta" className="hover:text-white">Condiciones de venta</Link>
      </div>
      © {new Date().getFullYear()} FAUNNY · Precios con IVA incluido · Nuestros productos son piensos complementarios y no sustituyen el consejo veterinario.
    </div>
  </footer>
);
